/* eslint-disable no-shadow */

import {
  GetterTree, MutationTree, ActionTree, Module
} from 'vuex';
import IFinance from '@/models/interfaces/IFinance';
import PurchaseTypeGroup from '@/enums/PurchaseTypeGroup';
import PurchaseType from '@/enums/PurchaseType';
import FundingType from '@/enums/FundingType';
import FinanceState from '../states/finance-state';
import IFinanceState from '../states/interfaces/finance-state.d';
import IRootState from '../states/interfaces/index.d';

export const state: IFinanceState = new FinanceState();

export const getters: GetterTree<IFinanceState, IRootState> = {
  finance: (state): IFinance => state.finance,
  purchaseTypes: (state): PurchaseType[] => state.finance.purchaseTypes,
  purchaseTypeGroup: (state): PurchaseTypeGroup => state.finance.purchaseTypeGroup,
  maintenanceRequired: (state): boolean => state.finance.maintenanceRequired
};

export const mutations: MutationTree<IFinanceState> = {
  setConsiderStock: (state: IFinanceState, considerStock: boolean) => {
    state.finance.considerStock = considerStock;
  },
  setPurchaseTypeGroup: (state: IFinanceState, purchaseTypeGroup: PurchaseTypeGroup) => {
    state.finance.purchaseTypeGroup = purchaseTypeGroup;
  },
  setPurchaseTypes: (state: IFinanceState, purchaseTypes: PurchaseType[]) => {
    state.finance.purchaseTypes = purchaseTypes;
  },
  setFundingType: (state: IFinanceState, fundingType: FundingType) => {
    state.finance.fundingType = fundingType;
  },
  setFinanceTerm: (state: IFinanceState, financeTerm: number) => {
    state.finance.financeTerm = financeTerm;
  },
  setDepositMonths: (state: IFinanceState, depositMonths: number) => {
    state.finance.depositMonths = depositMonths;
  },
  setAnnualMileage: (state: IFinanceState, annualMileage: number) => {
    state.finance.annualMileage = annualMileage;
  },
  setMonthlyBudget: (state: IFinanceState, monthlyBudget: number) => {
    state.finance.monthlyBudget = monthlyBudget;
  },
  setMaintenanceRequired: (state: IFinanceState, maintenanceRequired: boolean) => {
    state.finance.maintenanceRequired = maintenanceRequired;
  },
  setDepositAmount: (state: IFinanceState, depositAmount: number) => {
    state.finance.depositAmount = depositAmount;
  },
  setResetPurchaseTypeGroupFields: (state:IFinanceState) => {
    state.finance.financeTerm = 0;
    state.finance.annualMileage = 0;
    state.finance.depositMonths = 0;
    state.finance.depositAmount = 0;
    state.finance.maintenanceRequired = false;
    state.finance.monthlyBudget = 0;
    state.finance.purchaseTypes = [];
    state.finance.fundingType = FundingType.NotSet;
  }
};

export const actions: ActionTree<IFinanceState, IRootState> = {
  submitConsiderStock: ({ commit }, considerStock: boolean) => {
    commit('setConsiderStock', considerStock);
  },
  submitPurchaseTypeGroup: ({ commit }, purchaseTypeGroup: PurchaseTypeGroup) => {
    commit('setPurchaseTypeGroup', purchaseTypeGroup);
  },
  submitPurchaseTypes({ commit }, purchaseTypes: PurchaseType[]) {
    commit('setPurchaseTypes', purchaseTypes);
  },
  submitFundingType({ commit }, fundingType: FundingType) {
    commit('setFundingType', fundingType);
  },
  submitFinanceTerm({ commit }, financeTerm: number) {
    commit('setFinanceTerm', financeTerm);
  },
  submitDepositMonths({ commit }, depositMonths: number) {
    commit('setDepositMonths', depositMonths);
  },
  submitAnnualMileage({ commit }, annualMileage: number) {
    commit('setAnnualMileage', annualMileage);
  },
  submitMonthlyBudget({ commit }, monthlyBudget: number) {
    commit('setMonthlyBudget', monthlyBudget);
  },
  submitMaintenanceRequired({ commit }, maintenanceRequired: boolean) {
    commit('setMaintenanceRequired', maintenanceRequired);
  },
  submitDepositAmount({ commit }, depositAmount: number) {
    commit('setDepositAmount', depositAmount);
  },
  submitResetPurchaseTypeGroupFields({ commit }) {
    commit('setResetPurchaseTypeGroupFields');
  }
};

export const financeModule: Module<IFinanceState, IRootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
